import { ConfiguracionExterna } from '@/Modelos/ConfiguracionExterna';
import {VuexModule,Module,Mutation,Action} from 'vuex-module-decorators'
import { Inmueble } from './../Modelos/Inmueble';
const merge=(t:any,s:any)=>{const o=Object,a=o.assign;for(const k of o.keys(s))s[k]instanceof o&&a(s[k],merge(t[k],s[k]));return a(t||{},s),t}

@Module({namespaced:true})
export default class WidgetMapStore extends VuexModule
{

  public inmuebles:Array<Inmueble> = [];
  

  @Mutation
  public setInmuebles(inmuebles: Array<Inmueble>):void
  {
    this.inmuebles = inmuebles;
  }

  @Action
  public updateInmuebles(inmuebles:Array<Inmueble>):void
  {
    this.context.commit('setInmuebles',inmuebles);
  }

  public configuracionExterna:ConfiguracionExterna = {
    mapaAltura: '600px',
    showCluster: false,
    marcador: {
      icon:{
        tipoColor: true
      }
    },
    theme: {
      mapa:'leaflet'
    }
  };
  
  @Mutation
  public setConfiguracionExterna(config: ConfiguracionExterna):void
  {
    this.configuracionExterna = merge(this.configuracionExterna,config);
  }

  @Action
  public updateConfiguracionExterna(config: ConfiguracionExterna):void
  {
    this.context.commit('setConfiguracionExterna',config);
  }


/*
  get getInmueble():Array<Inmueble>
  {
    return this.inmuebles;
  }
  */
}
